import Navbar from "../components/layout/Navbar";
import AnnouncementBar from "../components/layout/AnnouncementBar";
import Footer from "../components/Footer";

import ShopHero from "../components/shop/ShopHero";
import CategoryTabs from "../components/shop/CategoryTabs";
import SearchBar from "../components/shop/SearchBar";
import FilterSidebar from "../components/shop/FilterSidebar";
import ProductGrid from "../components/shop/ProductGrid";
import { ShopProvider } from "../context/ShopContext";
import Pagination from "../components/shop/Pagination";
import SortDropdown from "../components/shop/SortDropdown";



// export default function Shop() {

//     return(
//         <ShopProvider>

// <>
// <AnnouncementBar/>

// <Navbar/>

// <ShopHero/>

// <CategoryTabs/>

// <div className="max-w-7xl mx-auto px-6 py-20">

// <div className="grid lg:grid-cols-4 gap-12">

// <FilterSidebar/>

// <ProductGrid/>

// </div>

// </div>

// <Footer/>

// </>
// </ShopProvider>

//     )

// }
export default function Shop() {

    return(
        <ShopProvider>

<>
<AnnouncementBar />
<Navbar />

<ShopHero />
<CategoryTabs />

<div className="max-w-7xl mx-auto px-6 py-20">

    <div className="mb-8 flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">

        <SearchBar />

        <SortDropdown />

    </div>

    <div className="grid gap-12 lg:grid-cols-4">

        <FilterSidebar />

        <div className="lg:col-span-3">

            <ProductGrid />

            <Pagination />

        </div>

    </div>

</div>

<Footer />

</>
</ShopProvider>

    )

}